import PropTypes from 'prop-types';
import { isNil, isEmpty } from 'ramda';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import DatePresenter from '../presenters/DatePresenter';
import { emptyValueToDash } from '../utils/values';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    auth0Id: PropTypes.string,
    fullName: PropTypes.string,
    birthdate: PropTypes.string,
    phoneNumber: PropTypes.string,
    gender: PropTypes.string,
    createdAt: PropTypes.string,
    email: PropTypes.string,
    fastCash: PropTypes.shape(),
    membershipState: PropTypes.string,
    fullName: PropTypes.string,
    referrer: PropTypes.shape(),
    invitedUsers: PropTypes.arrayOf(PropTypes.shape),
  },
  {
    createdAtReadable(user) {
      const createdAt = this.createdAt(user);
      return DatePresenter.shortFormattedDate(createdAt);
    },
    phoneNumberReadable(user) {
      const phoneNumber = this.phoneNumber(user);

      return emptyValueToDash(phoneNumber);
    },
    hasReferrer(user) {
      const referrer = this.referrer(user);

      return !isNil(referrer);
    },
    hasInvitedUsers(user) {
      const invitedUsers = this.invitedUsers(user);

      return !isEmpty(invitedUsers);
    },
  }
);
